import React from "react";
import {
  Box,
  Button,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@components";
import { usePremiumFeaturesModal } from "@components/PremiumFeaturesModal";
import { usePortfolioLimit } from "@hooks/usePortfolioLimit";

const PortfolioLimitTooltipContent = ({
  onUpgradeClick,
}: {
  onUpgradeClick: () => void;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      gap={2.5}
    >
      <Typography variant="body3" fontWeight={400} color="textPrimary">
        {t("portfolioLimit.tooltipText")}
      </Typography>
      <Box alignSelf="center" display="flex" alignItems="center">
        <Button
          variant="primary"
          color="upgrade"
          size="small"
          onClick={onUpgradeClick}
          sx={{
            color: `${theme.palette.button.upgradeButton.textOnDefault} !important`,
          }}
        >
          {t("onlyForProBlock.updateToPro")}
        </Button>
      </Box>
    </Box>
  );
};

export const PortfolioLimitGate = ({
  children,
  renderLocked,
}: {
  children: React.ReactNode;
  renderLocked: React.ReactNode;
}) => {
  const { isLoading, isPortfolioLimitReached } = usePortfolioLimit();
  const { openPremiumModal, premiumModal } = usePremiumFeaturesModal();
  const isLessMd = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  if (isLoading) {
    return <Box sx={{ pointerEvents: "none" }}>{children}</Box>;
  }

  if (!isPortfolioLimitReached) return <>{children}</>;

  return (
    <>
      <Tooltip
        text={
          <PortfolioLimitTooltipContent onUpgradeClick={openPremiumModal} />
        }
        placement="top"
        maxWidth="300px"
        openOnClick={isLessMd}
      >
        <Box>{renderLocked}</Box>
      </Tooltip>
      {premiumModal}
    </>
  );
};
